module.exports = __webpack_public_path__ + "static/img/officeMail.3fecc6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/officeMail.svg
// module id = l5vN
// module chunks = 2